import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
// import '@fortawesome/fontawesome-free/css/all.css'

import '@mdi/font/css/materialdesignicons.css'
Vue.use(Vuetify)

const opts = {
    // icons: {
    //     iconfont: 'fa',
    // },
    theme: {
        light: true,
        themes: {
            light: {
                primary: '#2B7195',
                // secondary: '#424242',
                // accent: '#82B1FF',
                error: '#C91D1D',
                // info: '#2196F3',
                success: '#73B234',
                warning: '#E8A530',
            },
        },
    }
}

export default new Vuetify(opts)